module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/SR-5665c643657a68b8bda71413e579d485.png";